// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container .swiper-slide {
  width: auto;
  max-height: 400px;
}

.container {
  max-width: 725px;
  padding: 4rem 2.5rem;
  margin: 0 auto;
}
.swiper_container {
  height: 50%;
  padding: 1rem 0;
  position: relative;
}

.swiper-slide {
  width: 20rem;
  height: 42rem;
  position: relative;
}



.swiper-slide-shadow-left,
.swiper-slide-shadow-right {
  display: none;
}

.slider-controler {
  position: relative;
  bottom: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-controler .swiper-button-next {
  left: 88% !important;
  transform: translateX(-58%) !important;
}

@media (max-width:767px) {
  .slider-controler .swiper-button-prev {
    left: 80% !important;
    transform: translateX(-30%) !important;
  }
  .slider-controler .swiper-button-next {
    left: 90% !important;
    transform: translateX(-80%) !important;
  }
  
}
@media (max-width: 500px) {
  .container {
    padding: 4rem 1rem;
  }
}

.slider-controler .slider-arrow {
  background: var(--white);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  left: 82%;
  transform: translateX(-42%);
  filter: drop-shadow(0px 8px 24px rgba(18, 28, 53, 0.1));
}

.slider-controler .slider-arrow ion-icon {
  font-size: 2rem;
  color: #222224;
}

.slider-controler .slider-arrow::after {
  content: "";
}

.swiper-pagination {
  position: relative;
  width: 8rem !important;
  bottom: 5rem;
  left: 55%;
  color: #fff;
}

.swiper-pagination-progressbar {
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.slide-number {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }`, "",{"version":3,"sources":["webpack://./src/components/Home/Carousel/Carousel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;;;AAIA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE;IACE,oBAAoB;IACpB,sCAAsC;EACxC;EACA;IACE,oBAAoB;IACpB,sCAAsC;EACxC;;AAEF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;EAC7B","sourcesContent":[".container .swiper-slide {\n  width: auto;\n  max-height: 400px;\n}\n\n.container {\n  max-width: 725px;\n  padding: 4rem 2.5rem;\n  margin: 0 auto;\n}\n.swiper_container {\n  height: 50%;\n  padding: 1rem 0;\n  position: relative;\n}\n\n.swiper-slide {\n  width: 20rem;\n  height: 42rem;\n  position: relative;\n}\n\n\n\n.swiper-slide-shadow-left,\n.swiper-slide-shadow-right {\n  display: none;\n}\n\n.slider-controler {\n  position: relative;\n  bottom: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-controler .swiper-button-next {\n  left: 88% !important;\n  transform: translateX(-58%) !important;\n}\n\n@media (max-width:767px) {\n  .slider-controler .swiper-button-prev {\n    left: 80% !important;\n    transform: translateX(-30%) !important;\n  }\n  .slider-controler .swiper-button-next {\n    left: 90% !important;\n    transform: translateX(-80%) !important;\n  }\n  \n}\n@media (max-width: 500px) {\n  .container {\n    padding: 4rem 1rem;\n  }\n}\n\n.slider-controler .slider-arrow {\n  background: var(--white);\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  left: 82%;\n  transform: translateX(-42%);\n  filter: drop-shadow(0px 8px 24px rgba(18, 28, 53, 0.1));\n}\n\n.slider-controler .slider-arrow ion-icon {\n  font-size: 2rem;\n  color: #222224;\n}\n\n.slider-controler .slider-arrow::after {\n  content: \"\";\n}\n\n.swiper-pagination {\n  position: relative;\n  width: 8rem !important;\n  bottom: 5rem;\n  left: 55%;\n  color: #fff;\n}\n\n.swiper-pagination-progressbar {\n  background-color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n.slide-number {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
